// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2iuir","content":"RecentSearches_content__3vsrG"};